import type { ReactNode } from 'react';

export type PresetArtProps = { className?: string };

/**
 * One filled circle, one white silhouette, dark features (learner picture PRD
 * §4). Fixed colours rather than theme tokens: both registers are light
 * themes, and a picture the learner chose should look the same wherever it is
 * drawn. Decorative: the radio or the bubble around it carries the name.
 */
export function PresetFrame({
  background,
  className,
  children,
}: PresetArtProps & { background: string; children: ReactNode }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
      <circle cx="32" cy="32" r="32" fill={background} />
      {children}
    </svg>
  );
}
